export const roomReducers = {
  // THIS KEY FOR MATCHING ROOM CARD DESCRIPTION
  setDescriptionKey: (state, { payload }) => {
    state.descriptionOpenKey = payload;
    state.isCollapseRatePlan = false;
  },
  showAllRooms: (state, { payload }) => {
    // SHOW ALL ROOM FLAG FOR SHOW AVAILABLE ROOMS
    state.descriptionOpenKey = "";
    state.isRoomChangeFlag = payload;
    state.isCollapseRatePlan = false;
  },
  setCollapseRatePlan: (state, { payload }) => {
    //  FOR SHOWING AVAILABLE RATEPLAN OPTIONS
    state.descriptionOpenKey = "";
    state.isCollapseRatePlan = payload;
    state.isRoomChangeFlag = false;
  },
  setRatePlanCode: (state, { payload }) => {
    // SET NEW RATEPLAN CODE
    state.descriptionOpenKey = "";
    state.ratePlanCode = payload;
    state.isCollapseRatePlan = false;
  },
  resetRatePlan: (state) => {
    state.ratePlanCode = "";
  },
  selectRoom: (state, { payload }) => {
    // SELECT ROOM FROM THE ROOMTYPE ARRAY
    state.selectedRoom = [payload];
    state.isRoomChangeFlag = false;
  },

  //this is for setting selected rooms in the selectedRooms array
  setSelectedRooms: (state, { payload }) => {
    // const {index, ...rest} = payload
    // console.log({rest, index})
    // if(index !== undefined){
    //   let temp = [...state.selectedRooms]
    //   temp[index] = {...rest}
    //   state.selectedRooms = [...temp]
    // }
    const findActiveRoomIndex = state.roomCounts.findIndex(room => room.isActive);
    console.log({findActiveRoomIndex});
    if(findActiveRoomIndex !== -1){
     const temp = [...state.selectedRooms];
     temp[findActiveRoomIndex] = payload;
     state.selectedRooms = [...temp];
     for(let i = findActiveRoomIndex; i < state.roomCounts.length; i++){
      if(Object.keys(state.selectedRooms[i] || {}).length === 0){
        state.selectedRooms[i] = payload;
      }
     }
    }else{
      state.selectedRooms = [...state.selectedRooms, payload];
    }
  },
  //this is for setting room counts in the roomCounts array
  setRoomCount: (state, { payload }) => {
    // console.log({payload})
    // const hotelId = localStorage.getItem('hotelId') || 'c102';
    // const hotelDetails = JSON.parse(localStorage.getItem('allHotels')) || [];
    // const maxRoomPerPerson = hotelDetails.find(hotel => hotel.hotelId === hotelId)?.maxRoomPerPerson;
    // console.log({maxRoomPerPerson})
    // if(state.roomCounts.length >= maxRoomPerPerson){
    //   return;
    // }else{
      state.roomCounts = [...state.roomCounts, payload];
      if(!payload.isActive){
        state.selectedRooms = [...state.selectedRooms, state.selectedRooms[state.selectedRooms.length - 1] || {}];
      }
    // }
    state.allOptions2 = [...state.allOptions2, state.initialOptions];
  },
  //this is for setting room is active in the roomCounts array
  setRoomIsActive: (state, { payload }) => {
    state.roomCounts = state.roomCounts.map((room, index) => {
      if(index === payload){
        return {...room, isActive: true};
      }else{
        return {...room, isActive: false};
      }
    });
    // mark that next API update is due to active room switch
    state.isActiveRoomSwitch = true;
    console.log({state: state.allOptions});
    state.allOptions = state.allOptions2[payload];
    console.log({state: state.allOptions});
  },
  //this is for removing room count from the roomCounts array
  removeRoomCount: (state, { payload }) => {
    const removedIndex = payload;
    state.roomCounts = state.roomCounts.filter((_, index) => index !== removedIndex);
    state.selectedRooms = state.selectedRooms.filter((_, index) => index !== removedIndex);
    state.allOptions2 = state.allOptions2.filter((_, index) => index !== removedIndex);
    // set a new active room if any remain
    if (state.roomCounts.length > 0) {
      const newActiveIndex = Math.min(removedIndex, state.roomCounts.length - 1);
      state.roomCounts = state.roomCounts.map((room, idx) => ({
        ...room,
        isActive: idx === newActiveIndex,
      }));
      state.allOptions = state.allOptions2[newActiveIndex];
    } else {
      state.allOptions = [];
    }
    //remove costSItems2 from cost summary slice
  },
  //this is for updating room count in the roomCounts array
  updateRoomCount: (state, { payload }) => {
    const {index, ...rest} = payload
    console.log({rest, index})
    if(index !== undefined){
      let temp = [...state.roomCounts]
      temp[index] = { ...temp[index], ...rest }
      state.roomCounts = [...temp]
    }
  },
  // remove selected Rooms
  removeSelectedRoom: (state, { payload }) => {
    const {index} = payload
    state.selectedRooms[index] = {};
  },

  setBubble: (state, action) => {
    state.allOptions = action.payload;
  },
  setPrevBubble: (state, action) => {
    state.prevOptions = action.payload;
  },
  setAllOptions2: (state, { payload }) => {
    const {value, index} = payload;
    if(index !== undefined){
      let temp = [...state.allOptions2];
      temp[index] = value;
      state.allOptions2 = [...temp];
    }
  },
  setCancellationPolicy: (state, action) => {
    state.cancellationPolicy = action.payload;
  },
  // setPetPolicy: (state, action) => {
  //   state.petPolicy = action.payload;
  // },
  setCorpCode: (state, action) => {
    state.corpCode = action.payload;
  },
  setIsApiCall: (state, { payload }) => {
    state.isApiCall = payload;
  },
  setSelectedRatePlan: (state, { payload }) => {
    state.selectedRatePlan = payload;
  },
  resetCorpCode: (state) => {
    state.corpCode = "";
  },
  setIsCorpCategory: (state, { payload }) => {
    state.isCorpCategory = payload;
  },
  setRoomTypeId: (state, { payload }) => {
    state.roomTypeId = payload;
  },
  setTimeSpan: (state, { payload }) => {
    state.timeSpan = payload;
  },
  setHandleOpen: (state, action) => {
    state.isHandleOpen = action.payload;
  },
  setIsRoomAvailable: (state, { payload }) => {
    state.isRoomAvailable = payload
  },
  setPackagesDisabledIds: (state, { payload }) => {
    state.packageDisabledIds = payload
  },
  setVisitedRoomBookingPage: (state) => {
    state.isVisitedRoomBookingPage = true
  },
  setStatus: (state, { payload }) => {
    state.status = payload;
  }
};
